export const TOYOTA_RUC = 1792073634001;
export const CARLOS_LARREA_RUC = '1891709478001';
export const HIDROBO_RUC = '1090084247001';
